export default __webpack_public_path__ + "static/media/blog-post.3.f3cf63a6.md";